import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const { login, resetPassword, signup } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isRegistering) {
      if (password !== confirmPassword) {
        setError('Les mots de passe ne correspondent pas');
        return;
      }
      try {
        setError('');
        setLoading(true);
        await signup(email, password);
      } catch (error) {
        console.error('Registration error:', error);
        switch (error.code) {
          case 'auth/email-already-in-use':
            setError('Cette adresse e-mail est déjà utilisée. Veuillez vous connecter ou utiliser une autre adresse.');
            break;
          case 'auth/invalid-email':
            setError('L\'adresse e-mail n\'est pas valide.');
            break;
          case 'auth/operation-not-allowed':
            setError('L\'inscription par e-mail/mot de passe n\'est pas activée.');
            break;
          case 'auth/weak-password':
            setError('Le mot de passe est trop faible. Il doit contenir au moins 6 caractères.');
            break;
          default:
            setError('Une erreur est survenue lors de l\'inscription. Veuillez réessayer.');
        }
      }
    } else {
      try {
        setError('');
        setLoading(true);
        await login(email, password);
      } catch (error) {
        console.error('Login error:', error);
        switch (error.code) {
          case 'auth/user-not-found':
            setError('Aucun compte n\'existe avec cette adresse e-mail.');
            break;
          case 'auth/wrong-password':
            setError('Le mot de passe est incorrect.');
            break;
          case 'auth/invalid-email':
            setError('L\'adresse e-mail n\'est pas valide.');
            break;
          default:
            setError('Échec de la connexion. Veuillez vérifier vos identifiants.');
        }
      }
    }
    setLoading(false);
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Veuillez saisir votre adresse e-mail');
      return;
    }
    try {
      setError('');
      setLoading(true);
      await resetPassword(email);
      setResetSent(true);
    } catch (error) {
      console.error('Password reset error:', error);
      switch (error.code) {
        case 'auth/user-not-found':
          setError('Aucun compte n\'existe avec cette adresse e-mail.');
          break;
        case 'auth/invalid-email':
          setError('L\'adresse e-mail n\'est pas valide.');
          break;
        default:
          setError('Échec de la réinitialisation du mot de passe. Veuillez vérifier votre adresse e-mail.');
      }
    }
    setLoading(false);
  };

  return (
    <main className="App-main">
      <div className="login-container">
        <h2>{isRegistering ? 'Inscription' : 'Connexion'}</h2>
        {error && <div className="error-message">{error}</div>}
        {resetSent && (
          <div className="success-message">
            Les instructions de réinitialisation du mot de passe ont été envoyées à votre adresse e-mail.
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle-button"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex="-1"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </button>
            </div>
          </div>
          {isRegistering && (
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
              <div className="password-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </div>
          )}
          <button type="submit" className="submit-button" disabled={loading}>
            {isRegistering ? "S'inscrire" : "Se connecter"}
          </button>
          {!isRegistering && (
            <button
              type="button"
              className="forgot-password-button"
              onClick={handleForgotPassword}
              disabled={loading}
            >
              Mot de passe oublié ?
            </button>
          )}
          <button
            type="button"
            className="switch-mode-button"
            onClick={() => {
              setIsRegistering(!isRegistering);
              setError('');
              setResetSent(false);
            }}
          >
            {isRegistering ? "Déjà inscrit ? Connectez-vous" : "Pas encore de compte ? Inscrivez-vous"}
          </button>
        </form>
      </div>
    </main>
  );
}

export default Login;
